module.exports = {
  "country": "BE",
  "artist": "Blanche",
  "song": "City Lights",
  "year": "2017",
  "place": "4",
  "spotify": "5v3oL4EOGmzFjo7S3O7IFH"
};